import React from 'react';
import { connect, ConnectedProps } from '@cerebral/react';
import { state, sequences } from 'app/pwa/app.cerebral';

import { useText } from 'common/hooks';
import { ICON } from 'resources/constants';

import { Wrapper, PageWrapper, Icon, PageText, Button } from './elements';

type Props = {
  readonly currentPage: number;
  readonly pageCount: number;
};

const deps = {
  toplistExpanded: state.challenge.visualisations.toplistExpanded,
  expandToplistClicked: sequences`challenge.visualisations.expandToplistClicked`,
  changeLeaderboardPageClicked: sequences`challenge.visualisations.changeLeaderboardPageClicked`,
};

function LeaderboardTeam({
  toplistExpanded,
  expandToplistClicked,
  changeLeaderboardPageClicked,
  currentPage,
  pageCount,
}: Props & typeof deps & ConnectedProps): React.ReactElement {
  const t = useText();

  return (
    <Wrapper>
      <Button onClick={() => expandToplistClicked()}>
        {toplistExpanded
          ? t('challenge.toplist.footer.hide')
          : t('challenge.toplist.footer.expand')}
      </Button>
      {toplistExpanded && (
        <PageWrapper>
          <Icon
            icon={ICON.keyboardArrowLeft}
            disabled={currentPage === 0}
            onClick={() => {
              if (currentPage === 0) return;

              changeLeaderboardPageClicked({ page: currentPage - 1 });
            }}
          />
          <PageText>
            {t('challenge.toplist.footer.page', {
              currentPage: currentPage + 1,
              pageCount,
            })}
          </PageText>
          <Icon
            icon={ICON.keyboardArrowRight}
            disabled={currentPage + 1 === pageCount}
            onClick={() => {
              if (currentPage + 1 === pageCount) return;

              changeLeaderboardPageClicked({ page: currentPage + 1 });
            }}
          />
        </PageWrapper>
      )}
    </Wrapper>
  );
}

export default connect<Props, typeof deps>(deps, LeaderboardTeam);
